import { StaffEntity } from '@aiwyn/api';
import { CxpStaffMember } from '../../models';

export function mapStaffEntityToStaffMember(entity: StaffEntity): CxpStaffMember {
  return {
    id: entity.id,
    name: entity.name,
    email: entity.email,
  };
}
